import { DocsCodificationInterface } from '../interfaces/docs-codification.interface';
import { DocsCodificationFields } from './docs-codification-fields.model';

export class DocsCodification implements DocsCodificationInterface {
  /**
   *
   */
  id?: number;

  /**
   *
   */
  name: string;

  /**
   *
   */
  isEnabled: boolean;

  /**
   *
   */
  codificationFields: DocsCodificationFields[] = [];

  /**
   *
   */
  indexRule: string;

  /**
   * Create an instance of DocsCodificationModel.
   *
   * @param docsCodification The docs codification settings.
   */
  constructor(docsCodification: DocsCodificationInterface) {
    this.id = docsCodification.id;
    this.name = docsCodification.name;
    this.isEnabled = docsCodification.isEnabled;
    this.codificationFields =
      docsCodification.codificationFields?.map((field) => new DocsCodificationFields(field)) || this.codificationFields;
    this.indexRule = docsCodification.indexRule;
  }
}
